import InlineSvg from 'svg-inline-react'

const icons = {
  'logo': require('../../../../assets/svgs/logo.svg'),
  'monthly-summary-report': require('../../../../assets/svgs/monthly-summary-report.svg'),
  /** *******************************\
     Patient Banner (pb prefix)
     \******************************** */
  'pbHospitalInactive': require('../../../../assets/svgs/pb_hospital_inactive.svg'),
  /** *******************************\
     ReviewOfSystems human body icons
     \******************************** */
  'rosAllergies': require('../../../../assets/svgs/ros_allergies.svg'),
  'rosCardiovascular': require('../../../../assets/svgs/ros_cardiovascular.svg'),
  'rosDigestive': require('../../../../assets/svgs/ros_digestive.svg'),
  'rosEndocrine': require('../../../../assets/svgs/ros_endocrine.svg'),
  'rosEnte': require('../../../../assets/svgs/ros_ente.svg'),
  'rosGeneral': require('../../../../assets/svgs/ros_general.svg'),
  'rosGenitourinary': require('../../../../assets/svgs/ros_genitourinary.svg'),
  'rosHematologic': require('../../../../assets/svgs/ros_hematologic.svg'),
  'rosIntegumentary': require('../../../../assets/svgs/ros_integumentary.svg'),
  'rosMentalhealth': require('../../../../assets/svgs/ros_mentalhealth.svg'),
  'rosMusculoskeletal': require('../../../../assets/svgs/ros_musculoskeletal.svg'),
  'rosNeurological': require('../../../../assets/svgs/ros_neurological.svg'),
  'rosRespiratory': require('../../../../assets/svgs/ros_respiratory.svg'),

  /** *******************************\
     Encounter icons
     \******************************** */
  'encounterPhone': require('../../../../assets/svgs/phone.svg'),
  'encounterEmail': require('../../../../assets/svgs/phone.svg'),
  'encounterMobile': require('../../../../assets/svgs/phone.svg'),
  'encounterCaseManagement': require('../../../../assets/svgs/case-management.svg'),
  'encounterVirtual': require('../../../../assets/svgs/virtual.svg')
}

export function Svg ({ src, element = 'i', title, ...rest }) {
  return (
    <InlineSvg
      element={element}
      src={icons[src]}
      title={title}
      {...rest}
    />
  )
}
